



import { Vue } from "vue-property-decorator";
import AppMessage from "@/components/app-message.vue";
export default Vue.extend({
  components: { AppMessage },
  data(){
      return{
          message : this.$t('anmobi.erreurs.no_palette')
      }
  },
  props: {
  }
});
